<template>
  <div>
		<winning-numbers-sidebar :open.sync="sidebarOpen" :results="externalLotteriesResults"></winning-numbers-sidebar>
		<v-btn id="external-results-btn" @click="sidebarOpen = !sidebarOpen" style="z-index: 4">
			Winning Numbers
		</v-btn>
	  <v-responsive :aspect-ratio="16 / 9">
		  <iframe
			  v-if="channelName && channelName.length > 0"
			  id="frame"
			  :src="
          `https://player.twitch.tv/?channel=${channelName}&parent=quicklotto.tv`
        "
			  frameborder="0"
			  scrolling="no"
			  allowfullscreen="true"
		  >
		  </iframe>
	  </v-responsive>
    <v-row>
      <v-img contain height="200" src="./images/logo.png"></v-img>
    </v-row>
    <v-row justify="center">
      <v-col cols="auto">
        <v-btn id="see-it-live-btn" @click="scrollToStream">
          See it live
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        lg="4"
        sm="6"
        cols="12"
        v-for="result in results"
        :key="`${result.date}-${result.sortition.id}`">
        <result-display class="result-card" :result="result"> </result-display>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ResultDisplay from "./ResultDisplay.vue";
import BaseStream from "../BaseStream.js";

export default {
  name: "Stream",
  components: {
    ResultDisplay
  },
  extends: BaseStream
};
</script>

<style scoped lang="scss">
@import "css/variables";

.result-card {
  border: 5px solid rgba($font-color-3, 0.8);
  padding: 5px;
  margin-left: 5px;
  margin-bottom: 5px;
  border-radius: 20px;
}

#see-it-live-btn {
  background-color: rgba($font-color, 0.8);
  color: white;
}

#frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
